const SVGContainerStyles = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
};
const containerDimensionsStyles = {
    minHeight: '36px',
    minWidth: '36px',
    'input:hover ~ &, input:active ~ &, input:focus ~ &': {
        bg: 'baseBgWeakActive',
    },
    'input:hover:disabled ~ &': {
        bg: 'transparent',
    },
};
export const checkedRadioIconContainerStyles = Object.assign(Object.assign({}, containerDimensionsStyles), { display: 'none', 'input:checked ~ &': Object.assign(Object.assign({}, SVGContainerStyles), { color: 'baseText' }), 'input:disabled ~ &': {
        color: 'neutralTextWeak',
    } });
export const uncheckedRadioIconContainerStyles = Object.assign(Object.assign(Object.assign({}, containerDimensionsStyles), SVGContainerStyles), { 'input:checked ~ &': {
        display: 'none',
    } });
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUmFkaW9TdHlsZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9jb21tb25zL0Nob2NvRm9ybS9DaG9jb1JhZGlvSW5wdXQvUmFkaW9TdHlsZXMudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVBLE1BQU0sa0JBQWtCLEdBQXVCO0lBQzdDLE9BQU8sRUFBRSxNQUFNO0lBQ2YsVUFBVSxFQUFFLFFBQVE7SUFDcEIsY0FBYyxFQUFFLFFBQVE7SUFDeEIsWUFBWSxFQUFFLEtBQUs7Q0FDcEIsQ0FBQztBQUVGLE1BQU0seUJBQXlCLEdBQXVCO0lBQ3BELFNBQVMsRUFBRSxNQUFNO0lBQ2pCLFFBQVEsRUFBRSxNQUFNO0lBRWhCLG9EQUFvRCxFQUFFO1FBQ3BELEVBQUUsRUFBRSxrQkFBa0I7S0FDdkI7SUFDRCwwQkFBMEIsRUFBRTtRQUMxQixFQUFFLEVBQUUsYUFBYTtLQUNsQjtDQUNGLENBQUM7QUFFRixNQUFNLENBQUMsTUFBTSwrQkFBK0IsbUNBQ3ZDLHlCQUF5QixLQUM1QixPQUFPLEVBQUUsTUFBTSxFQUNmLG1CQUFtQixrQ0FDZCxrQkFBa0IsS0FDckIsS0FBSyxFQUFFLFVBQVUsS0FFbkIsb0JBQW9CLEVBQUU7UUFDcEIsS0FBSyxFQUFFLGlCQUFpQjtLQUN6QixHQUNGLENBQUM7QUFFRixNQUFNLENBQUMsTUFBTSxpQ0FBaUMsaURBQ3pDLHlCQUF5QixHQUN6QixrQkFBa0IsS0FDckIsbUJBQW1CLEVBQUU7UUFDbkIsT0FBTyxFQUFFLE1BQU07S0FDaEIsR0FDRixDQUFDIn0=